import { useTranslation } from 'react-i18next';

export default function After2025() {
  const { t } = useTranslation('');
  return (
    <section className="catalogue-table">
      <h3 className="m-0 text-center font-semibold">{t('catalogue.title')}</h3>
      <p className="text-center">
        <i>{t('catalogue.description')}</i>
      </p>

      <table>
        <tr>
          <th>STT</th>
          <th style={{ width: '8%' }}>{t('catalogue.symbol')}</th>
          <th>{t('catalogue.name')}</th>
        </tr>
        <tr>
          <td>1</td>
          <td>R01</td>
          <td>
            {t('catalogue.R01.title')}:
            <ul>
              <li>
                {t('catalogue.R01.proposalForScienceAndTechnologyProject')}:
                <a href="/files/2025/R01.[SEO].ĐX.ĐT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R01.scientificProjectProposal')}:
                <a href="/files/2025/R01.[SEO].ĐX.ĐA.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R01.experimentalProductionProjectProposal')}:
                <a href="/files/2025/R01.[SEO].ĐX.SXTN.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>R02</td>
          <td>
            {t('catalogue.R02.title1')}:
            <ul>
              <li>
                {t('catalogue.R02.scientificAndTechnologicalProjectExplanation')}:
                <a href="/files/2025/R02.[SEO].TM.ĐT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.explanatoryReportForScientificProject')}:
                <a href="/files/2025/R02.[SEO].TM.ĐA.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.explanatoryReportForExperimentalProductionProject')}:
                <a href="/files/2025/R02.[SEO].TM.SXTN.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
            {t('catalogue.R02.title2')}:
            <ul>
              <li>
                {t('catalogue.R02.projectProposalBudgetEstimate')}:
                <a href="/files/2025/R02.[REQ].DUTOAN-ĐT_ĐA.xlsx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.scientificProfile')}:
                <a href="/files/2025/R02.[REQ].LLKH.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.confirmationOfCollaborativeExecution')}:
                <a href="/files/2025/R02.[OTP].PHTH.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.explanationForCompletingTheDocument')}:
                <a href="/files/2025/R02.[REQ].GT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R02.recordOfReviewForRegistrationDocumentAndTaskAssignment')}:
                <a href="/files/2025/R02.[REQ].KT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>R03</td>
          <td>
            {t('catalogue.R03.title1')}:
            <ul>
              <li>
                {t('catalogue.R03.contractForUniversityTypeAB')}:
                <a href="/files/2025/R03.[SEO].HĐ.ĐT.AB.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractForUniversityTypeC')}:
                <a href="/files/2025/R03.[SEO].HĐ.ĐT.C.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.scientificProjectContract')}:
                <a href="/files/2025/R03.[SEO].HĐ.ĐA.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractForExperimentalProductionProject')}:
                <a href="/files/2025/R03.[SEO].HĐ.SXTN.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
            {t('catalogue.R03.title2')}:
            <ul>
              <li>
                {t('catalogue.R03.contractTerminationCompleteForUniversityTypeAB')}:
                <a href="/files/2025/R03.[OTP].TL.HT.ĐT.AB.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractTerminationCompleteForUniversityTypeC')}:
                <a href="/files/2025/R03.[OTP].TL.HT.ĐT.C.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.scientificProjectContractTerminationComplete')}:
                <a href="/files/2025/R03.[OTP].TL.HT.ĐA.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractTerminationCompleteForExperimentalProductionProject')}:
                <a href="/files/2025/R03.[OTP].TL.HT.SXTN.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
            {t('catalogue.R03.title3')}:
            <ul>
              <li>
                {t('catalogue.R03.contractTerminationNotCompleteForUniversityTypeAB')}:
                <a href="/files/2025/R03.[OTP].TL.KHT.ĐT.AB.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractTerminationNotCompleteForUniversityTypeC')}:
                <a href="/files/2025/R03.[OTP].TL.KHT.ĐT.C.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.scientificProjectContractTerminationNotComplete')}:
                <a href="/files/2025/R03.[OTP].TL.KHT.ĐA.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.contractTerminationNotCompleteForExperimentalProductionProject')}:
                <a href="/files/2025/R03.[OTP].TL.KHT.SXTN.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
            {t('catalogue.R03.title4')}:
            <ul>
              <li>
                {t('catalogue.R03.requestFormForBudgetItemAdjustment')}:
                <a href="/files/2025/R03.[OTP].ĐC.KP.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.extensionRequestForm')}:
                <a href="/files/2025/R03.[OTP].ĐC.GH.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.requestFormForAdjustmentOfProjectProposal')}:
                <a href="/files/2025/R03.[OTP].ĐC.TM.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.midtermDocumentReviewMinutes')}:
                <a href="/files/2025/R03.[REQ].KT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.summaryReport')}:
                <a href="/files/2025/R03.[REQ].BC.TT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R03.finalReport')}:
                <a href="/files/2025/R03.[REQ].BC.TK.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>R04</td>
          <td>
            {t('catalogue.R042025.title')}
            <ul>
              <li>
                {t('catalogue.R042025.minutesOfAcceptanctOrContractLiquidationDocumentReview')}:
                <a href="/files/2025/R04.[REQ].KT.NT.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>5</td>
          <td>R05</td>
          <td>
            {t('catalogue.R052025.title')}:
            <ul>
              <li>
                {t('catalogue.R052025.minutesOfReviewForResultRegistrationDocuments')}:
                <a href="/files/2025/R05.[REQ].KT.docx">
                  {t('formLayout.action.download')} <i className="pi pi-download ml-1" />
                </a>
              </li>
              <li>
                {t('catalogue.R052025.resultRegistrationForm')}:
                <a href="/files/2025/R05.[REQ].ĐK.KQ.docx">
                  {t('formLayout.action.download')}
                  <i className="pi pi-download ml-1" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>6</td>
          <td>R08</td>
          <td>
            {t('catalogue.R08')}:
            <a href="/files/R08-BAO-CAO-TONG-KET.docx">
              {t('formLayout.action.download')} <i className="pi pi-download ml-1" />
            </a>
          </td>
        </tr>
        <tr>
          <td>7</td>
          <td>R09</td>
          <td>
            {t('catalogue.R09')}:
            <a href="/files/R09-DANG-KY-KET-QUA.docx">
              {t('formLayout.action.download')} <i className="pi pi-download ml-1" />
            </a>
          </td>
        </tr>
      </table>
    </section>
  );
}
